<template>
    <div class="cz2__steps-options">
        <steps-options-body
            v-if="currentGroupCode === 'Body'"
            @updateNavigation="updateNavigation"
            class="bounce-in"
        />

        <steps-options-head
            v-if="currentGroupCode === 'Head'"
            @updateNavigation="updateNavigation"
            class="bounce-in"
        />

        <steps-options-hair
            v-if="currentGroupCode === 'Hair'"
            @updateNavigation="updateNavigation"
            class="bounce-in"
        />

        <steps-options-beard
            v-if="currentGroupCode === 'Beard'"
            @updateNavigation="updateNavigation"
            class="bounce-in"
        />

        <steps-options-glasses
            v-if="currentGroupCode === 'Glasses'"
            @updateNavigation="updateNavigation"
            class="bounce-in"
        />

        <steps-options-torso
            v-if="currentGroupCode === 'Torso'"
            @updateNavigation="updateNavigation"
            class="bounce-in"
        />

        <steps-options-legs
            v-if="currentGroupCode === 'Legs'"
            @updateNavigation="updateNavigation"
            class="bounce-in"
        />

        <steps-options-accessories1
            v-if="currentGroupCode === 'Accessories1'"
            @updateNavigation="updateNavigation"
            class="bounce-in"
        />

        <steps-options-accessories2
            v-if="currentGroupCode === 'Accessories2'"
            @updateNavigation="updateNavigation"
            class="bounce-in"
        />

        <steps-options-accessories2
            v-if="currentGroupCode === 'Accessories3'"
            @updateNavigation="updateNavigation"
            class="bounce-in"
        />

        <steps-options-attach-packs
            v-if="currentGroupCode === 'Packs'"
            @updateNavigation="updateNavigation"
            class="bounce-in"
        />

        <steps-options-pets
            v-if="currentGroupCode === 'Pets'"
            @updateNavigation="updateNavigation"
            class="bounce-in"
        />

        <!-- Should not bounce -->
        <transition name="cz2__fade">
            <steps-options-name
                v-if="currentGroupCode === 'Name'"
                @updateNavigation="updateNavigation"
                :validate="validateCount"
            />
        </transition>

        <!-- Should not bounce -->
        <transition name="cz2__fade">
            <steps-options-contact
                v-if="currentGroupCode === 'Contact'"
                @updateNavigation="updateNavigation"
            />
        </transition>

        <transition name="cz2__fade">
            <steps-options-confirm
                v-if="currentGroupCode === 'Confirm'"
                @updateNavigation="updateNavigation"
            />
        </transition>

        <transition name="cz2__fade__absolute">
            <steps-options-checkout
                v-if="currentGroupCode === 'Checkout'"
                @updateNavigation="updateNavigation"
            />
        </transition>

        <div
            v-if="currentGroupCode !== 'Checkout' && !isSplashPage && currentGroupCode !== 'Confirm'"
            ref="actionButtonWrapper"
            :class="[
                'cz2__steps-options__navigation',
                { 'cz2__steps-options__navigation--name': currentGroupCode === 'Name' },
                { 'cz2__steps-options__navigation--review': currentGroupCode === 'Review' },
            ]"
        >
            <div
                v-if="!isNameStep && !isReviewStep && !isCheckoutStep"
                class="cz2__help-placeholder"
            />

            <div class="cz2__steps-options__navigation-content">
                <!-- SPELLING BEE START: Prev button, modified. -->
                <sb-button
                    v-if="isSpellingBee && showBackButton"
                    :variant="isNameStep && !isKiosk ? 'tertiary' : 'secondary'"
                    :disabled="!canGoBack"
                    @click="goBack"
                    heightVariant="large"
                    :background="sbNavigationButtonBackground"
                >
                    <span>
                        {{$t('ACTION_BACK')}}
                    </span>
                </sb-button>
                <!-- SPELLING BEE END: Standard prev button below. -->

                <btn
                    v-else-if="!isSpellingBee && showBackButton"
                    :disabled="!canGoBack"
                    @click="goBack"
                    onDark
                    class="cz2__btn--secondary cz2__btn--back"
                >
                    <img
                        v-if="isMobile && !isReviewStep"
                        src="../assets/icons/chevron.svg"
                        width="13"
                        height="19"
                        class="cz2__btn--back-arrow"
                    >
                    <span v-else>
                        {{$t('ACTION_BACK')}}
                    </span>
                </btn>

                <!-- SPELLING BEE START: Next button, modified. -->
                <sb-button
                    v-if="isSpellingBee && canProceed"
                    :disabled="!canGoNext || (hasError && !isOptional)"
                    @click="goNext"
                    :variant="sbMainVariant"
                    :heightVariant="isReviewStep ? 'medium' : 'large'"
                    :background="sbNavigationButtonBackground"
                >
                    <span v-if="currentGroupCode === 'Review'">
                        {{isKiosk ? $t('ACTION_NEXT') : $t('ACTION_BUY_POP')}}
                    </span>
                    <loading-spinner
                        v-else-if="isValidating"
                        :spinner-size="19"
                    />
                    <span v-else>
                        {{$t('ACTION_NEXT')}}
                    </span>
                </sb-button>
                <!-- SPELLING BEE END: Standard next button below. -->

                <p
                    v-if="!isReviewStep && !isCheckoutStep"
                    class="cz2__subtotal"
                >
                    {{ $t('SUBTOTAL') }}<br>
                    <span class="cz2__subtotal-price">
                        {{ totalPrice }}
                    </span>
                </p>

                <btn
                    v-if="!isSpellingBee && canProceed"
                    primary
                    onDark
                    :disabled="disableGoNext"
                    @click="goNext"
                    :class="[
                        {
                            'cz2__btn--wider': currentGroupCode === 'Checkout',
                            'cz2__btn--wide': currentGroupCode === 'Review',
                            'cz2__btn--disabled': showNextDisabled,
                        },
                    ]"
                >
                    <span v-if="currentGroupCode === 'Name'">
                        {{ nextButtonCopy }}
                    </span>
                    <loading-spinner
                        v-else-if="isValidating"
                        :spinner-size="19"
                    />
                    <span v-else>
                        {{$t('ACTION_NEXT')}}
                    </span>
                </btn>
            </div>

            <!-- Hard-coded navigation... -->
            <div
                v-if="currentGroupCode === 'Name'"
                class="cz2__steps-options__actions"
            >
                <!-- SPELLING BEE START -->
                <sb-button
                    v-if="!isTwoPack && isSpellingBee"
                    variant="quaternary"
                    :heightVariant="isReviewStep ? 'medium' : 'large'"
                    @click="saveAvatarSb"
                >
                    {{$t('ACTION_SAVE_AVATAR')}}
                </sb-button>
                <!-- SPELLING BEE END -->

                <!-- SPELLING BEE START -->
                <sb-share-buttons v-if="isSpellingBee" />
                <!-- SPELLING BEE END -->
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__steps-options {
            pointer-events: none;

            height: 100%;
        }

        .cz2__steps-options__shared {
            position: absolute;
            bottom: 0;

            pointer-events: auto;

            height: var(--steps-options-height);
            width: 100%;

            display: flex;
            flex-direction: column;

            .cz2__steps-options__list-wrapper {
                // Don't add var(--layout-spacing) since we want to have no visible gap.
                padding-bottom: calc(var(--steps-options-nav-height));
            }

            @include respond-above(lg) {
                right: 0;

                width: 50%;
                height: 100%;

                .cz2__steps-options__list-wrapper {
                    // Same, avoid visible gap: (var(--layout-spacing) * 3) + (var(--layout-gap) * 3) +
                    padding-bottom: calc(var(--steps-options-nav-height));
                }
            }
        }

        .cz2__steps-options__navigation {
            z-index: 1;
            position: absolute;
            bottom: 0;

            box-shadow: 0px -12px 11px -18px rgba(0, 0, 0, 0.55);

            width: 100%;
            height: var(--steps-options-nav-height);

            padding: 12px 20px;
            background-color: color(v2BlueMedium);
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;

            pointer-events: auto;

            button {
                height: 39px;
                width: 50%;
            }

            .cz2__steps-options__navigation-content {
                display: flex;
                flex: 1;
                align-items: center;
                justify-content: end;
                gap: 12px;
            }

            &:not(.cz2__steps-options__navigation--review) {
                .cz2__btn--back {
                    width: 39px;
                    height: 39px;
                    padding: 0;
                    flex: none;
                }
                .cz2__btn--back-arrow {
                    transform: rotateY(180deg);
                }
            }

            &.cz2__steps-options__navigation--name,
            &.cz2__steps-options__navigation--review {
                background: none;
                box-shadow: none;
            }

            .cz2__subtotal {
                order: -1;
                font-family: 'Proxima Nova';
                font-size: 14px;
                text-align: center;
                color: white;
            }

            // Reserve space for help button
            .cz2__help-placeholder {
                order: -1;
                width: 43px;
                height: 43px;
            }

            .cz2__subtotal-price {
                margin-top: 2px;
                display: inline-block;
                font-weight: bold;
                font-size: 16px;
                white-space: nowrap;
            }

            @include respond-above(md) {
                button {
                    padding-top: 0;
                    padding-bottom: 0;
                    height: 39px;
                    width: 50%;
                }
            }

            @include respond-above(lg) {
                right: 0;
                gap: 16px;

                &.cz2__steps-options__navigation--name,
                &.cz2__steps-options__navigation--review {
                    --steps-options-nav-height: 136px;

                    .cz2__subtotal {
                        display: none;
                    }
                }

                &:not(.cz2__steps-options__navigation--name, .cz2__steps-options__navigation--review) {
                    width: 50%;

                    .cz2__btn--back {
                        flex: auto;
                        width: 50%;
                        border-radius: 32px;
                        padding: 6px 32px;
                        height: 48px;
                    }
                }

                button {
                    height: 48px;

                    font-size: 22px;
                }

                &.cz2__steps-options__navigation--name {
                    button {
                        width: 250px;
                    }
                }

                &.cz2__steps-options__navigation--name {
                    .cz2__steps-options__navigation-content {
                        width: stretch;
                        justify-content: center;
                    }
                }

                .cz2__help-placeholder {
                    display: none;
                }

                .cz2__subtotal {
                    order: 0;
                }

                .cz2__subtotal-price {
                    font-size: 18px;
                }
            }
        }
    }

    #cz2.cz2:not(.cz2__is-kiosk) {
        .cz2__steps-options__navigation--name,
        .cz2__steps-options__navigation--review {
            background-color: black;
            justify-content: center;

            @include respond-above(lg) {
                background-color: transparent;

                .cz2__steps-options__navigation-content {
                    padding-top: 24px;
                    flex-direction: column;
                    gap: 0;
                    max-width: 398px;

                    button {
                        width: 100%;
                    }

                    .cz2__btn--back {
                        order: 1;
                        background: none;
                        color: white;

                        &:hover {
                            box-shadow: none;
                        }

                        &:focus {
                            &::before {
                                border: none;
                            }
                        }
                    }
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__steps-options__shared {
            height: var(--steps-options-height);
            width: 100%;
            padding-bottom: var(--steps-options-nav-height);
        }
        .cz2__steps-options__list-wrapper {
            padding-bottom: 0 !important;
        }
        .cz2__steps-options__navigation--name {
            background-color: color(v2BlueMedium);
            width: 100% !important;
            padding-top: 21.5px;
            padding-bottom: 21.5px;
            height: 107px;
            button,
            .cz2__btn--back {
                flex: auto;
                height: 64px;
                width: 50%;
                font-size: 22px;
            }
        }

        .cz2__steps-options__navigation--name {
            background-color: #033F70;

            .cz2__subtotal {
                display: block;
            }
        }

        .cz2__steps-options__actions {
            display: none;
        }

        .cz2__steps-options__navigation {
            width: 100%;
        }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   ▗▄▄▖▗▄▄▖ ▗▄▄▄▖▗▖   ▗▖   ▗▄▄▄▖▗▖  ▗▖ ▗▄▄▖    ▗▄▄▖ ▗▄▄▄▖▗▄▄▄▖
    //  ▐▌   ▐▌ ▐▌▐▌   ▐▌   ▐▌     █  ▐▛▚▖▐▌▐▌       ▐▌ ▐▌▐▌   ▐▌
    //   ▝▀▚▖▐▛▀▘ ▐▛▀▀▘▐▌   ▐▌     █  ▐▌ ▝▜▌▐▌▝▜▌    ▐▛▀▚▖▐▛▀▀▘▐▛▀▀▘
    //  ▗▄▄▞▘▐▌   ▐▙▄▄▖▐▙▄▄▖▐▙▄▄▖▗▄█▄▖▐▌  ▐▌▝▚▄▞▘    ▐▙▄▞▘▐▙▄▄▖▐▙▄▄
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    #cz2.cz2.cz2__is-sb {
        .cz2__steps-options__list-wrapper {
            padding-bottom: calc(var(--steps-options-nav-height-sb));
        }

        .cz2__steps-options__shared {
            height: calc(52% + 30px);

            @include respond-above(md) {
                height: calc(52% + 30px);
            }

            @include respond-above(lg) {
                height: 100%;
            }
        }

        @include respond-above(lg) {
            .cz2__steps-options__shared {
                padding-top: 0;
            }
        }

        .cz2__steps-options__navigation {
            display: flex;
            justify-content: space-evenly;
            background-color: color(sbDarkGold);
            padding-top: 0;
            padding-bottom: 0;

            height: calc(var(--steps-options-nav-height-sb));

            box-shadow: 0px -2px 4px 0px #00000040;

            pointer-events: none;

            button {
                pointer-events: auto;
            }
        }

        .cz2__steps-options__navigation--name {
            background-color: color(sbDarkGold);

            @include respond-above(lg) {
                justify-content: center;
                background-color: transparent;
                gap: 32px;

                box-shadow: none;
            }
        }

        .cz2__steps-options__navigation--name,
        .cz2__steps-options__navigation--review {
            box-shadow: none;
        }
    }

    #cz2.cz2.cz2__is-sb.cz2__is-review-step {
        .cz2__steps-options__navigation {
            background-color: transparent;
            height: auto;
        }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // SPELLING BEE: KIOSK
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    #cz2.cz2.cz2__is-kiosk.cz2__is-sb {
        .cz2__steps-options__shared {
            height: calc(52% + 86px);

            padding-bottom: calc(var(--steps-options-nav-height-sb));
        }

        .cz2__steps-options__navigation {
            background-color: color(sbDarkGold);
            position: absolute;
        }
    }

    #cz2.cz2.cz2__is-sb.cz2__is-kiosk.cz2__is-review-step {
        .cz2__steps-options__navigation {
            background-color: color(sbDarkGold);
            position: absolute;
            bottom: 0;
            margin-bottom: 0;
            padding: 0 20px;
            height: calc(var(--steps-options-nav-height-sb));
            justify-content: center;

            gap: 16px;

            button {
                max-width: none;
                width: 100%;
            }
        }
    }

    #cz2.cz2.cz2__is-sb.cz2__is-kiosk.cz2__is-name-step {
        .cz2__steps-options__navigation {
            background-color: color(sbDarkGold);
            position: absolute;
            bottom: 0;
            margin-bottom: 0;
            padding: 0 20px;
            height: calc(var(--steps-options-nav-height-sb));
            justify-content: center;

            gap: 16px;

            button {
                max-width: none;
                width: 100%;
            }
        }
    }

    #cz2.cz2.cz2__is-mariners:not(.cz2__is-name-step):not(.cz2__is-review-step) {
        .cz2__steps-options__navigation {
            border-top: 1px solid rgba(255, 255, 255, 0.11);
            background-color: #000;
        }
    }

    #cz2.cz2.cz2__is-mariners {
        .cz2__steps-options__navigation {
            .cz2__btn--primary {
                margin: 0;
            }
        }
    }
</style>

<script>
    import { spring, timeline } from 'motion';

    import { formatPrice } from '../helpers/formatPrice';

    import Btn from './ui/Btn.vue';
    import SbButton from './SbButton.vue';
    import LoadingSpinner from './ui/LoadingSpinner.vue';

    import SbShareButtons from './SbShareButtons.vue';

    import StepsOptionsBody from './StepsOptionsBody.vue';
    import StepsOptionsHead from './StepsOptionsHead.vue';
    import StepsOptionsHair from './StepsOptionsHair.vue';
    import StepsOptionsBeard from './StepsOptionsBeard.vue';
    import StepsOptionsGlasses from './StepsOptionsGlasses.vue';
    import StepsOptionsTorso from './StepsOptionsTorso.vue';
    import StepsOptionsLegs from './StepsOptionsLegs.vue';
    import StepsOptionsAccessories1 from './StepsOptionsAccessories1.vue';
    import StepsOptionsAccessories2 from './StepsOptionsAccessories2.vue';
    import StepsOptionsAttachPacks from './StepsOptionsAttachPacks.vue';
    import StepsOptionsPets from './StepsOptionsPets.vue';
    import StepsOptionsName from './StepsOptionsName.vue';
    import StepsOptionsContact from './StepsOptionsContact.vue';
    import StepsOptionsCheckout from './StepsOptionsCheckout.vue';
    import StepsOptionsConfirm from './StepsOptionsConfirm.vue';

    export default {
        components: {
            Btn,
            LoadingSpinner,

            SbButton,
            SbShareButtons,

            StepsOptionsBody,
            StepsOptionsHead,
            StepsOptionsBeard,
            StepsOptionsHair,
            StepsOptionsGlasses,
            StepsOptionsTorso,
            StepsOptionsLegs,
            StepsOptionsAccessories1,
            StepsOptionsAccessories2,
            StepsOptionsAttachPacks,
            StepsOptionsPets,
            StepsOptionsName,
            StepsOptionsContact,
            StepsOptionsCheckout,
            StepsOptionsConfirm,
        },

        data() {
            return {
                hasNext: false,
                canGoBack: false,
                canGoNext: false,
                showNextDisabled: false,
                nextSpecial: null,
                previousSpecial: null,
                nextPressed: null,
                backPressed: null,
                validateCount: 0,
                isValidating: false,
                invalid: null,
                sbButtonWrapperWidth: 0,
            };
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },

            isMariners() {
                return this.$store.state.isMariners;
            },

            didNavigateFromMainMenu() {
                return this.$store.state.customizer.didNavigateFromMainMenu;
            },

            options() {
                return this.$store.state.customizer.options;
            },

            showBackButton() {
                if (this.isKiosk && this.currentGroupCode === 'Name') {
                    return true;
                }

                return true;
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            isSplashPage() {
                return this.$store.state.selectedStep === 'splash' || this.$store.state.selectedStep === 'splashSelector';
            },

            isOptional() {
                return this.currentGroup.custom && this.currentGroup.custom['fun-optional'] === 'true';
            },

            hasError() {
                const bad = this.$store.state.customizer.alertGroups;

                return bad.length > 0 && this.currentGroupCode != null && bad.includes(this.currentGroupCode);
            },

            canBuyPop() {
                return this.options && this.options.canBuyPop;
            },

            canProceed() {
                return this.isNameStep ? this.canBuyPop : this.hasNext;
            },

            isBodyStep() {
                return this.currentGroupCode === 'Body';
            },

            isNameStep() {
                return this.currentGroupCode === 'Name';
            },

            isCheckoutStep() {
                return this.currentGroupCode === 'Checkout';
            },

            isContactStep() {
                return this.currentGroupCode === 'Contact';
            },

            isReviewStep() {
                return this.currentGroupCode === 'Review';
            },

            groups() {
                if (this.viewController == null) {
                    return [];
                }

                return this.viewController.blueprint.groups.filter((g) => g.custom && g.custom['fun-show-in-nav'] === 'true');
            },

            currentGroup() {
                return this.$store.state.customizer.currentGroup;
            },

            currentGroupCode() {
                return this.currentGroup?.code;
            },

            previousGroup() {
                return this.$store.getters.previousGroup;
            },

            nextGroup() {
                return this.$store.getters.nextGroup;
            },

            seenGroups() {
                return this.$store.state.customizer.seenGroups;
            },

            isSubMenuOpen() {
                return this.$store.state.customizer.isSubMenuOpen;
            },

            isSubMenuManualOpen() {
                return this.currentGroup.custom?.['fun-color-sub-menu-auto-open'] === 'false';
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            isFirstPop() {
                return this.$store.state.customizer.viewController === this.$store.getters.popControllers[0];
            },

            pop2Started() {
                return Object.keys(this.$store.state.customizer.seenGroupsByController).length > 1;
            },

            showSwitchPopModal() {
                return this.isTwoPack && this.isFirstPop && !this.pop2Started;
            },

            windowWidth() {
                return this.$store.state.windowWidth;
            },

            sbNavigationButtonBackground() {
                if (this.isNameStep && this.windowWidth >= 1024 && !this.isKiosk) {
                    return '#fff';
                }

                if (this.isReviewStep && !this.isKiosk) {
                    return '#fff';
                }

                return '#9a7D4b';
            },

            sbMainVariant() {
                if (this.isNameStep) {
                    return 'primary';
                }

                if (this.isReviewStep && !this.isKiosk) {
                    return 'buy';
                }

                return 'primary';
            },

            totalPrice() {
                return formatPrice(this.$store.state, this.$store.getters.cartTotal, 'standard');
            },

            isMobile() {
                return this.$store.state.customizer.isMobile;
            },

            boxName() {
                return this.$store.state.customizer.boxName;
            },

            nextButtonCopy() {
                let buttonCopy = this.$t('ACTION_NAME_NEXT_DESKTOP');

                if (this.isMobile) {
                    buttonCopy = this.$t('ACTION_NAME_NEXT_MOBILE');
                }

                if (this.isKiosk) {
                    buttonCopy = this.$t('ACTION_NAME_NEXT_KIOSK');
                }

                return buttonCopy;
            },

            disableGoNext() {
                return (!this.canGoNext && !this.isBodyStep) || (this.hasError && !this.isOptional);
            },
        },

        watch: {
            currentGroupCode() {
                this.triggerStepChangeAnimation();
            },

            isSubMenuOpen() {
                this.triggerStepChangeAnimation();
            },

            invalid() {
                if (this.invalid != null && !this.invalid) {
                    if (this.currentGroupCode === 'Name') {
                        // Done validating name, go to next step
                        if (this.showSwitchPopModal) {
                            this.$store.dispatch('log', {
                                level: 'info',
                                message: 'Showing pop switch modal',
                            });

                            this.$store.dispatch('showSwitchPopModal', true);
                        } else {
                            this.$store.dispatch('log', {
                                level: 'info',
                                message: `Going to the special group ${this.nextSpecial} from ${this.currentGroupCode}`,
                            });

                            this.$store.dispatch('showGroup', {
                                code: this.nextSpecial,
                            });
                        }
                    }
                }
            },
        },

        methods: {
            updateNavigation(current) {
                this.nextSpecial = null;
                this.previousSpecial = null;

                Object.assign(this.$data, current);

                if (current.showNextDisabled == null) {
                    this.showNextDisabled = false;
                }

                if (current.nextPressed == null) {
                    this.nextPressed = null;
                }
            },

            goNext() {
                // this.$store.dispatch('scrollToApp');
                this.logBodyEvent();
                this.logStageEvent();

                if (this.nextPressed) {
                    if (this.nextPressed() === false) {
                        return;
                    }
                }

                if (this.disableGoNext) {
                    return;
                }

                if (this.isBodyStep && !this.canGoNext) {
                    // Show skin tone modal if no tone has been selected.
                    this.$store.dispatch('showSkinToneModal', true);
                } else if (this.isSubMenuManualOpen && !this.isSubMenuOpen) {
                    // Manually open color sub-menu with the Next button
                    this.$store.dispatch('setIsSubMenuOpen', true);
                } else if (this.nextSpecial === 'Reset') {
                    this.$store.dispatch('resetCustomizations');
                    this.$store.dispatch('selectStep', 'splash');
                } else if (this.nextSpecial && this.nextSpecial !== 'Name' && this.currentGroupCode !== 'Name') {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: `Going to the special group ${this.nextSpecial} from ${this.currentGroupCode}`,
                    });

                    this.$store.dispatch('showGroup', {
                        code: this.nextSpecial,
                    });
                } else if (this.nextGroup) {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: `Going to the next group ${this.nextGroup.code} from ${this.currentGroupCode}`,
                    });

                    this.$store.dispatch('showGroup', this.nextGroup);
                } else if (this.currentGroupCode === 'Name') {
                    // Trigger name field validation
                    this.validateCount += 1;
                    this.isValidating = true;
                    this.invalid = true;
                }
            },

            saveAvatarSb() {
                setTimeout(() => {
                    this.emitter.$emit('saveSbAvatar');
                }, 100);
            },

            goBack() {
                // this.$store.dispatch('scrollToApp');

                if (this.backPressed) {
                    this.backPressed();
                }

                if (!this.canGoBack) {
                    return;
                }

                if (this.isSubMenuOpen) {
                    this.$store.dispatch('setIsSubMenuOpen', false);
                } else if (this.previousSpecial) {
                    const actual = this.groups.find((g) => g.code === this.previousSpecial);

                    if (actual) {
                        this.$store.dispatch('log', {
                            level: 'info',
                            message: `Going to the previous group ${actual.code} from ${this.currentGroupCode}`,
                        });

                        this.$store.dispatch('showGroup', actual);
                    } else {
                        this.$store.dispatch('log', {
                            level: 'info',
                            message: `Going to the previous special group ${this.previousSpecial} from ${this.currentGroupCode}`,
                        });

                        this.$store.dispatch('showGroup', {
                            code: this.previousSpecial,
                        });
                    }
                } else if (this.previousGroup) {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: `Going to the previous group ${this.previousGroup.code} from ${this.currentGroupCode}`,
                    });

                    this.$store.dispatch('showGroup', this.previousGroup);
                } else if (this.isTwoPack && !this.isFirstPop) {
                    this.$store.dispatch('showSwitchPopModal', true);
                } else {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: `No previous group, resetting to splash from ${this.currentGroupCode}`,
                    });

                    if (this.isKiosk) {
                        // Hard reset.
                        window.location.reload();
                    } else {
                        // No previous group, go to splash.
                        this.$store.dispatch('resetCustomizations');
                    }
                }
            },

            logBodyEvent() {
                // Log body event when next is clicked from the Tone screen
                if (this.currentGroupCode === 'Body' && this.isSubMenuOpen && window.dataLayer) {
                    window.dataLayer.push({
                        event: 'pop_people_body',
                    });
                }
            },

            logStageEvent() {
                if (this.currentGroup?.name) {
                    // Strip html tags out of accessory step names
                    const previousGroupName = this.currentGroup?.name.replace(/(<([^>]+)>)/ig, '');

                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'pop_people_stage',
                            pop_people_stage_reached: previousGroupName,
                        });
                    }
                }
            },

            setFocusOnFirstButton() {
                const buttonWrapper = this.$refs.actionButtonWrapper;
                const firstButton = buttonWrapper.querySelector('button');

                firstButton.focus();
            },

            triggerStepChangeAnimation() {
                const parentElement = document.querySelector('.cz2__steps-options');
                const height = parentElement.offsetHeight;

                setTimeout(() => {
                    timeline(
                        [
                            [
                                '.bounce-in',
                                { y: height },
                                { stiffness: 616 },
                                { mass: 1 },
                                { damping: 30 },
                                { easing: spring(), duration: 0.3 },
                            ],
                            [
                                '.bounce-in',
                                { y: -30 },
                                { duration: 0.15 },
                            ],
                            [
                                '.bounce-in',
                                { y: 5 },
                                { duration: 0.15 },
                            ],
                            [
                                '.bounce-in',
                                { y: 0 },
                                { stiffness: 616 },
                                { mass: 1 },
                                { damping: 30 },
                                { easing: spring(), duration: 0.3 },
                            ],
                        ],
                    );

                    const mainNavigationButton = document.getElementById('main-navigation-button');
                    if (mainNavigationButton && this.didNavigateFromMainMenu) {
                        mainNavigationButton.focus();
                        mainNavigationButton.removeAttribute('data-reclaim-focus');
                        this.$store.dispatch('setDidNavigateFromMainMenu', false);
                    }
                }, 10);
            },
        },
    };
</script>
